var map = {
	"./bg_.jpg": 9482,
	"./bg_about.jpg": 6453,
	"./bg_contact.jpg": 5323,
	"./bg_fees.jpg": 2081,
	"./bg_services.jpg": 1896,
	"./bg_testimonials.jpg": 817,
	"./bg_what-to-expect.jpg": 8420
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4551;